import React, { useState } from 'react'
import ApprovedModelIcon from 'components/icons/ApprovedModelIcon'
import LeftArrow from 'components/icons/LeftArrow'
import {
  Container,
  LeftSection,
  RightSection,
  SectionName,
} from 'modules/Roles/NewRoleCreation/Partials/Header/style'
import Button from 'components/Button'
import RoutePath from 'components/RoutePath'
import { TopHeading } from 'modules/Roles/Style/style'
import { EmptyElement } from '../../../../../components/UIComponents/CommonStyledDiv'
import { useNavigate } from 'react-router-dom'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import CloseRoleDrawer from 'components/CloseRolePopup'
import moment from "moment";
import { normalizeEligibilityCriteria } from 'helpers/formHelpers'
const Header = ({
  isEditingRole,
  isEditRoleOnView,
  roleLoading,
  currentStep,
  subEvents,
  handleNext,
  updateJobRole,
  values,
  jobId,
  setCollegeDrawer,
  onPublishClick,
  handleBack,
  publishDisabled,
  handleRepublishRole,
  isEdited,
  isDateOnlyEdited,
  rePublishedPublishDisabled,
  stepData,
  saveAsDraftJobRole,
  buttonLoading
}) => {
  const navigate = useNavigate()
  const basicCompleteSteps = [2, 3, 4]
  const [publishDrawerConfig, setPublishDrawerConfig] = useState(null)
  const allStepsCompleted =
    stepData &&
    basicCompleteSteps.every(stepKey =>
      stepData.some(step => step.key === stepKey && step.completed === true)
    )
    const stripHtml = html => {
      return (html || '').replace(/<[^>]*>?/gm, '').trim()
    }
  return (
    <>
      <Container spaceBetween>
      <LeftSection centerVertically>
        <EmptyElement
          className="left-arrow"
          style={{
            cursor: 'pointer',
          }}
          onClick={() => navigate('/rolePage')}
        >
          <LeftArrow />
        </EmptyElement>
        <SectionName column>
          <RoutePath
            from="Role"
            on={isEditingRole ? 'Edit Role' : 'New Role'}
            path="/rolePage"
          />
          <TopHeading>
            {isEditingRole ? 'Edit Role' : 'Add New Role'}
          </TopHeading>
        </SectionName>
      </LeftSection>
      <RightSection>
        {currentStep > 0 &&
          !publishDisabled &&
          !rePublishedPublishDisabled &&
          !isEditRoleOnView &&
          subEvents?.includes('SAVE AS DRAFT') && (
            <Button.Secondary
              htmlType="submit"
              form="rolesForm"
              text="Save as draft"
              disabled={stepData[1].completed !== true || roleLoading}
              onClick={() => {
                if (jobId === undefined || jobId === null) {
                  saveAsDraftJobRole(values)
                } else {

                  const arr = values?.jobDetails?.yearOfExperience || []

                  // Group values in pairs [int, dec] → number int.dec
                  const decimalResult = []
                  for (let i = 0; i < arr.length; i += 2) {
                    if (arr[i] !== undefined && arr[i + 1] !== undefined) {
                      decimalResult.push(Number(`${arr[i]}.${arr[i + 1]}`)) // 👈 convert string → number
                    }
                  }

                  const filteredRounds = values?.interviewWorkFlow?.rounds?.filter(round => {
                    const name = (round.name || '').trim()
                    const type = (round.type || '').trim()
                    const description = stripHtml(round.description)
                    return name !== '' && type !== '' && description !== ''
                  })
                  // Sanitize jobRolePoc to include only non-empty objects
                  const sanitizedJobRolePoc = Array.isArray(values?.corporateDetails?.jobRolePoc)
                    ? values.corporateDetails.jobRolePoc.filter(
                        p =>
                          p &&
                          typeof p === 'object' &&
                          !Array.isArray(p) &&
                          Object.keys(p).length > 0
                      )
                    : []
                  const payload = {
                    ...values,
                    corporateDetails: {
                      ...values.corporateDetails,
                      jobRolePoc: sanitizedJobRolePoc,
                    },
                    jobDetails: {
                      ...values.jobDetails,
                      gigsDuration: Array.isArray(values?.jobDetails?.gigsDuration)
                        ? {}
                        : values?.jobDetails?.gigsDuration,
                      maxVacancies: !values?.jobDetails?.maxVacancies
                        ? 0
                        : values?.jobDetails?.maxVacancies,
                      yearOfExperience: decimalResult || [],
                    },
                    elgibilty: {
                      ...values.elgibilty,
                      eligibilityCriteria: normalizeEligibilityCriteria(
                        values?.elgibilty?.eligibilityCriteria
                      ),
                      historyArrearCount: {
                        count: values?.elgibilty?.historyArrearCount || 0,
                        condition: 'LTE',
                      },
                      arrearCount: {
                        count: values?.elgibilty?.arrearCount || 0,
                        condition: 'LTE',
                      },
                    },
                    interviewWorkFlow: {
                      rounds: filteredRounds,
                    },
                  }
                  if(payload?.ctc?.maxCompensation === ""){
                    payload.ctc.maxCompensation = 0
                  }
                  if(payload?.ctc?.minCompensation === ""){
                    payload.ctc.minCompensation = 0
                  }
                  updateJobRole({ ...payload, status: 0 }, jobId)
                  navigate('/rolePage')
                }
              }}
            />
          )}

        {currentStep > 0 && <Button.Primary text="Back" onClick={handleBack} />}
        {subEvents?.includes('PREVIEW & PUBLISH') && currentStep !== 6 && (
          <Button.Primary
            htmlType="submit"
            form="rolesForm"
            text={isEditRoleOnView ? 'Save & Preview' : 'Next '}
            loading={buttonLoading}
            //  disabled={roleLoading || currentStep < 4}
            onClick={async () => {
              await handleNext()
            }}
          />
        )}

        {currentStep === 6 && (
          <Button.Primary
            text={
              ((publishDisabled || rePublishedPublishDisabled) && isEdited) ||
              ((publishDisabled || rePublishedPublishDisabled) && isDateOnlyEdited)
                ? "Update"
                : "Publish"
            }
            disabled={!allStepsCompleted}
            onClick={() => {
              // ✅ First validate endDate and endTime
              const jobDetails = values?.jobDetails
              if (jobDetails?.endDate) {
                // Convert endDate
                let endDate = moment(jobDetails.endDate);
            
                // If endTime exists and is valid
                if (jobDetails?.endTime && moment(jobDetails.endTime).isValid()) {
                  let endTime = moment(jobDetails.endTime);
            
                  // If not default "00:00:00", adjust +5:30
                  if (!(endTime.hours() === 0 && endTime.minutes() === 0)) {
                    endTime.add(5, "hours").add(30, "minutes");
                  }
            
                  // Merge endDate with adjusted endTime
                  endDate.set({
                    hour: endTime.hours(),
                    minute: endTime.minutes(),
                    second: endTime.seconds(),
                  });
                } else {
                  // Default to 23:59 if no endTime
                  endDate.set({ hour: 23, minute: 59, second: 0 });
                }
            
                // Compare with current date-time
                if (endDate.isSameOrBefore(moment())) {
                   ErrorMessage(
                    "End Date & Time should be greater than or equal to current Date & Time"
                  );
                  return
                }
              }
            
              // ✅ Then continue with existing logic
              if (
                ((publishDisabled || rePublishedPublishDisabled) && isEdited) ||
                ((publishDisabled || rePublishedPublishDisabled) && isDateOnlyEdited)
              ) {
                return handleRepublishRole();
              }

              const isOffCampus = values?.jobDetails?.isForAll ?? false;

              if (onPublishClick) {
                if (isOffCampus) {
                  setPublishDrawerConfig({
                    description: <>Are you sure you want to <b>publish</b> this role?</>,
                    icon: ApprovedModelIcon,
                    onApprove: () => {
                      onPublishClick();
                      setPublishDrawerConfig(null);
                    },
                    closeText: 'No',
                    YesText: 'Yes',
                  });
                } else {
                  onPublishClick();
                }
              } else {
                setCollegeDrawer(true);
              }
            }}
            
          />
        )}
      </RightSection>
    </Container>

    {publishDrawerConfig && (
      <CloseRoleDrawer
        description={<>{publishDrawerConfig.description}</>}
        Icon={publishDrawerConfig.icon}
        showDrawer={true}
        setShowDrawer={() => setPublishDrawerConfig(null)}
        onCloseClick={() => setPublishDrawerConfig(null)}
        onApprove={publishDrawerConfig.onApprove}
        closeText={publishDrawerConfig.closeText}
        YesText={publishDrawerConfig.YesText}
      />
    )}
    </>
  )
}

export default Header
